import IconTickLarge from '@picsart/icons/IconTickLarge';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';
import cls from 'classnames';

import { ICopyInfoAlert } from './types';
import useStyles from './styles';

function CopyInfoAlert({ text, onClose, className }: ICopyInfoAlert) {
  const classes = useStyles();
  return (
    <div className={cls(classes.root, className)}>
      <IconTickLarge className={classes.icon} />
      <p className={classes.copyInfoText}>{text}</p>
      <IconCrossLarge className={cls(classes.closeIcon, classes.icon)} onClick={onClose} />
    </div>
  );
}

export default CopyInfoAlert;
